module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "safe-center container-fluid"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isModifyPwd),
      expression: "isModifyPwd"
    }]
  }, [_vm._v(_vm._s(_vm.$t('changePassword')))]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isModifyPwd),
      expression: "!isModifyPwd"
    }]
  }, [_vm._v(_vm._s(_vm.$t('setNewPassword')))])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "notice"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showSuccessNotice),
      expression: "showSuccessNotice"
    }],
    staticClass: "prompt-message"
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-envelope pull-left"
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.successPromptMessage))])])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "safe-center-content"
    }
  }, [_c('modify-password', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isModifyPwd),
      expression: "isModifyPwd"
    }],
    staticClass: "modify-set-pwd",
    on: {
      "doModify": _vm.doModifyPassword
    }
  }), _vm._v(" "), _c('setting-new-password', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isModifyPwd),
      expression: "!isModifyPwd"
    }],
    staticClass: "modify-set-pwd",
    on: {
      "settingNewPassword": _vm.settingNewPassword
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1c264ce9!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/safecenter/SafeCenter.vue
// module id = 1272
// module chunks = 1